/* BTeacher · Mapa hero
 * Web component <bteacher-map-hero>: selección de comunidad en mapa/lista,
 * tarjeta con datos del producto y animación de sobres (Web Animations API).
 * Coordenadas en el sistema del SVG (800 x 600).
 */
(() => {
  if (customElements.get('bteacher-map-hero')) return;

  const VW = 800;
  const VH = 600;
  const ORIGIN = [206, 250]; // borde derecho de la tarjeta de CV
  const PERIOD = 4200; // ms por ciclo de sobre
  const DOTS = {"andalucia":[[368,413],[483,364],[380,332],[490,362],[471,348],[391,338],[472,374],[326,366],[461,357],[390,395],[512,393],[405,401],[537,357],[481,312],[439,368],[403,416],[389,393],[399,402],[388,381],[380,365],[529,373],[517,347],[458,367],[425,341],[539,382],[447,392],[379,386],[498,311],[412,356],[493,402],[486,370],[391,311],[324,370]],"aragon":[[588,74],[583,114],[553,191],[542,136],[598,107],[532,116],[617,82]],"asturias":[[400,53],[347,41],[412,54],[345,53],[412,48],[357,45]],"baleares":[[738,236],[750,214],[676,266],[750,230],[737,220],[750,225]],"cantabria":[[458,42],[440,58],[457,48],[473,46]],"castilla-leon":[[365,179],[456,100],[436,145],[506,123],[468,146],[406,188],[394,106],[388,66],[406,216],[467,69],[358,184],[358,199],[493,119],[392,100]],"castilla-la-mancha":[[496,193],[518,200],[397,224],[430,229],[436,293],[503,219],[543,286],[518,258]],"cataluna":[[706,94],[713,77],[623,154],[668,112],[631,145],[664,81],[701,114],[697,103],[692,125],[680,132],[624,177],[657,140],[634,105],[632,180],[692,125],[700,83],[637,78],[671,144],[637,75],[716,91],[713,93],[619,158],[713,74],[636,115],[670,133],[674,87],[677,133],[694,82],[651,152],[686,110],[726,103],[649,109],[680,101]],"valencia":[[579,235],[587,280],[591,316],[594,275],[587,263],[593,304],[612,208],[602,217],[619,189],[572,251],[584,332],[602,224],[605,178],[604,300],[609,184],[599,235],[591,266],[555,247],[613,199],[605,267],[582,290],[587,234]],"extremadura":[[359,262],[351,251],[355,222],[348,250]],"galicia":[[303,103],[263,109],[313,94],[302,47],[266,69],[322,53],[251,59],[311,117],[266,82],[316,56],[299,110]],"madrid":[[460,181],[432,208],[466,202],[450,193],[464,224],[475,207],[455,230],[456,175],[464,173],[445,186],[466,179],[464,171],[434,212],[457,203],[459,203],[456,171],[476,202],[457,186],[479,218],[452,201],[465,189],[470,192],[456,172],[445,183],[427,211],[446,210],[447,202],[458,187],[466,211],[450,210],[461,186],[465,191],[445,209]],"murcia":[[531,327],[556,317],[567,309],[531,337],[553,344],[531,335],[576,314],[567,302]],"navarra":[[530,63],[528,80],[538,90],[515,84]],"pais-vasco":[[516,61],[518,46],[509,52],[523,47],[501,59],[496,64],[499,60],[507,64],[509,58],[491,47],[488,80],[484,57],[482,60],[488,64]],"la-rioja":[[494,101],[501,97],[527,106]],"canarias":[[253,523],[42,492],[104,538],[107,531],[238,542],[155,554],[99,531],[241,557]]};
  const CENTROIDS = {"andalucia":[423,364],"aragon":[578,138],"asturias":[367,49],"baleares":[736,224],"cantabria":[442,54],"castilla-leon":[413,132],"castilla-la-mancha":[489,247],"cataluna":[664,114],"valencia":[592,252],"extremadura":[356,270],"galicia":[292,75],"madrid":[458,199],"murcia":[558,330],"navarra":[535,79],"pais-vasco":[497,60],"la-rioja":[502,102],"canarias":[151,540]};

  const fmt = (n) => (n >= 1000 ? Math.floor(n / 1000) + '.' + String(n % 1000).padStart(3, '0') : String(n));
  const lowerFirst = (s) => (s ? s.charAt(0).toLowerCase() + s.slice(1) : s);

  const ENVELOPE_SVG =
    '<svg viewBox="0 0 18 12" focusable="false"><rect x="0.7" y="0.7" width="16.6" height="10.6" rx="1.6" fill="#fff" stroke="#0f2b60" stroke-width="1.3"/><path d="M1.2 1.4 9 7 16.8 1.4" fill="none" stroke="#0f2b60" stroke-width="1.3" stroke-linejoin="round"/></svg>';

  class BteacherMapHero extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) this.init();
      this.observe();
    }

    init() {
      this.initialized = true;

      this.mapEl = this.querySelector('.btm__map');
      this.dotsEl = this.querySelector('.btm__dots');
      this.fxEl = this.querySelector('.btm__fx');
      this.labelEl = this.querySelector('.btm__label');
      this.destEl = this.querySelector('[data-btm-dest]');
      this.ui = {
        title: this.querySelector('[data-btm-title]'),
        count: this.querySelector('[data-btm-count]'),
        note: this.querySelector('[data-btm-note]'),
        price: this.querySelector('[data-btm-price]'),
        compare: this.querySelector('[data-btm-compare]'),
        cta: this.querySelector('[data-btm-cta]'),
        upsell: this.querySelector('[data-btm-upsell]'),
        status: this.querySelector('[data-btm-status]'),
      };
      this.nationalNote = this.ui.note ? this.ui.note.textContent.trim() : '';
      this.chips = Array.from(this.querySelectorAll('.btm__chip'));
      this.paths = Array.from(this.querySelectorAll('.btm-region'));
      this.items = {};
      this.chips.forEach((chip) => {
        const d = chip.dataset;
        this.items[d.region] = {
          key: d.region,
          name: d.name,
          count: parseInt(d.count, 10) || 0,
          price: d.price,
          compare: d.compare || '',
          url: d.url,
          national: d.region === 'espana',
        };
      });

      this.animEnabled = this.dataset.animate === 'true';
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.anims = [];
      this.running = false;
      this.visible = false;
      this.shown = 0;

      this.renderDots();
      this.bindEvents();

      const first = this.items.espana ? 'espana' : this.chips[0] && this.chips[0].dataset.region;
      if (first) this.select(first, { instant: true, silent: true });
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.motion && this.motion.removeEventListener) this.motion.removeEventListener('change', this.onMotion);
      cancelAnimationFrame(this.countFrame);
    }

    renderDots() {
      const frag = document.createDocumentFragment();
      this.dots = [];
      let i = 0;
      Object.keys(this.items).forEach((key) => {
        const pts = DOTS[key];
        if (!pts) return;
        pts.forEach(([x, y]) => {
          const dot = document.createElement('span');
          dot.className = 'btm__dot';
          dot.dataset.region = key;
          dot.style.left = (x / VW) * 100 + '%';
          dot.style.top = (y / VH) * 100 + '%';
          dot.style.animationDelay = ((i * 0.37) % 2.8).toFixed(2) + 's';
          frag.appendChild(dot);
          this.dots.push(dot);
          i += 1;
        });
      });
      this.dotsEl.textContent = '';
      this.dotsEl.appendChild(frag);
    }

    bindEvents() {
      this.paths.forEach((path) => {
        const key = path.dataset.region;
        if (!this.items[key]) {
          path.classList.add('is-disabled');
          return;
        }
        path.addEventListener('click', () => this.select(key));
      });
      this.chips.forEach((chip) => chip.addEventListener('click', () => this.select(chip.dataset.region)));
      if (this.ui.upsell) this.ui.upsell.addEventListener('click', () => this.select('espana'));
      // Editor de temas: al seleccionar un bloque, se muestra su comunidad.
      this.addEventListener('shopify:block:select', (event) => {
        const chip = event.target.closest && event.target.closest('.btm__chip');
        if (chip) this.select(chip.dataset.region, { silent: true });
      });
    }

    select(key, opts = {}) {
      const item = this.items[key];
      if (!item) return;
      this.current = key;
      const all = item.national;

      this.paths.forEach((path) => {
        const k = path.dataset.region;
        if (!this.items[k]) return;
        const on = all || k === key;
        path.classList.toggle('is-on', on);
        path.classList.toggle('is-off', !on);
      });
      this.dots.forEach((dot) => dot.classList.toggle('is-lit', all || dot.dataset.region === key));
      this.chips.forEach((chip) => chip.setAttribute('aria-pressed', chip.dataset.region === key ? 'true' : 'false'));

      const phraseName = all ? lowerFirst(item.name) : item.name;
      const ui = this.ui;
      if (ui.title) ui.title.textContent = item.name;
      if (ui.note) ui.note.textContent = all ? this.nationalNote : (this.dataset.noteTemplate || '').replace('[comunidad]', item.name);
      if (ui.price) ui.price.textContent = item.price;
      if (ui.compare) {
        ui.compare.textContent = item.compare;
        ui.compare.hidden = !item.compare;
      }
      if (ui.cta) {
        ui.cta.textContent = (this.dataset.ctaTemplate || '').replace('[comunidad]', phraseName);
        ui.cta.href = item.url;
      }
      if (ui.upsell) ui.upsell.hidden = all || !this.items.espana;
      if (this.destEl) this.destEl.textContent = (this.dataset.sendingPrefix || '') + ' ' + phraseName;
      if (ui.status && !opts.silent) ui.status.textContent = item.name + ': +' + fmt(item.count) + ' centros, ' + item.price;

      this.countTo(item.count, opts.instant);
      this.placeLabel(all ? null : key, item);
      this.restart();
    }

    placeLabel(key, item) {
      const c = key && CENTROIDS[key];
      if (!c) {
        this.labelEl.hidden = true;
        return;
      }
      this.labelEl.textContent = item.name;
      this.labelEl.style.left = (c[0] / VW) * 100 + '%';
      this.labelEl.style.top = (c[1] / VH) * 100 + '%';
      this.labelEl.hidden = false;
    }

    countTo(target, instant) {
      cancelAnimationFrame(this.countFrame);
      const el = this.ui.count;
      if (!el) return;
      if (instant || this.motion.matches) {
        this.shown = target;
        el.textContent = '+' + fmt(target);
        return;
      }
      const from = this.shown;
      const t0 = performance.now();
      const tick = (now) => {
        const p = Math.min(1, (now - t0) / 650);
        const eased = 1 - Math.pow(1 - p, 3);
        this.shown = Math.round(from + (target - from) * eased);
        el.textContent = '+' + fmt(this.shown);
        if (p < 1) this.countFrame = requestAnimationFrame(tick);
      };
      this.countFrame = requestAnimationFrame(tick);
    }

    /* --- Animación de sobres ------------------------------------------- */
    observe() {
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onMotion && this.motion.removeEventListener) this.motion.removeEventListener('change', this.onMotion);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          (entries) => {
            this.visible = entries[0].isIntersecting;
            if (this.visible) this.start();
            else this.stop();
          },
          { threshold: 0.15 }
        );
        this.io.observe(this.mapEl);
      } else {
        this.visible = true;
        this.start();
      }
      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onMotion = () => this.restart();
      if (this.motion.addEventListener) this.motion.addEventListener('change', this.onMotion);
      if ('ResizeObserver' in window) {
        let timer;
        this.ro = new ResizeObserver(() => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            if (this.running) this.restart();
          }, 150);
        });
        this.ro.observe(this.mapEl);
      }
    }

    canAnimate() {
      return this.animEnabled && !this.motion.matches && this.visible && !document.hidden && typeof Element.prototype.animate === 'function';
    }

    restart() {
      this.stop();
      this.start();
    }

    stop() {
      this.anims.forEach((a) => a.cancel());
      this.anims = [];
      this.running = false;
      this.classList.remove('is-animating');
    }

    targets(key, count) {
      const pts = [];
      if (this.items[key] && this.items[key].national) {
        const all = [];
        Object.keys(this.items).forEach((k) => (DOTS[k] || []).forEach((p) => all.push(p)));
        if (!all.length) return pts;
        const step = all.length / count;
        for (let i = 0; i < count; i += 1) pts.push(all[Math.floor(i * step + (i % 3) * 2) % all.length]);
      } else {
        const list = DOTS[key] || [];
        if (!list.length) return pts;
        for (let i = 0; i < count; i += 1) pts.push(list[(i * 7 + 3) % list.length]);
      }
      return pts;
    }

    ensureFx(count) {
      if (this.envs && this.envs.length === count) return;
      this.fxEl.textContent = '';
      this.envs = [];
      this.pings = [];
      for (let i = 0; i < count; i += 1) {
        const ping = document.createElement('span');
        ping.className = 'btm__ping';
        const env = document.createElement('span');
        env.className = 'btm__env';
        env.innerHTML = ENVELOPE_SVG;
        this.fxEl.appendChild(ping);
        this.fxEl.appendChild(env);
        this.pings.push(ping);
        this.envs.push(env);
      }
    }

    start() {
      if (this.running || !this.canAnimate() || !this.current) return;
      const width = this.mapEl.clientWidth;
      const height = this.mapEl.clientHeight;
      if (!width || !height) return;
      const sx = width / VW;
      const sy = height / VH;
      const count = width < 520 ? 9 : 14;
      const targets = this.targets(this.current, count);
      if (!targets.length) return;
      this.ensureFx(count);

      const x0 = ORIGIN[0] * sx;
      const y0 = ORIGIN[1] * sy;
      targets.forEach(([tx, ty], i) => {
        const x1 = tx * sx;
        const y1 = ty * sy;
        const cx = (x0 + x1) / 2;
        const cy = Math.min(y0, y1) - (50 + Math.abs(tx - ORIGIN[0]) * 0.2) * sy;
        const frames = [];
        for (let k = 0; k <= 14; k += 1) {
          const u0 = k / 14;
          const u = 0.5 - 0.5 * Math.cos(Math.PI * u0);
          const a = (1 - u) * (1 - u);
          const b = 2 * (1 - u) * u;
          const c = u * u;
          const x = a * x0 + b * cx + c * x1;
          const y = a * y0 + b * cy + c * y1;
          frames.push({
            offset: u0 * 0.62,
            opacity: k === 0 || k === 14 ? 0 : 1,
            transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) translate(-50%,-50%) scale(' + (1 - 0.4 * u).toFixed(2) + ')',
          });
        }
        frames.push({ offset: 1, opacity: 0, transform: frames[frames.length - 1].transform });
        const delay = (-((i * 5) % count) * PERIOD) / count;
        this.anims.push(this.envs[i].animate(frames, { duration: PERIOD, iterations: Infinity, delay }));

        const ping = this.pings[i];
        ping.style.left = (tx / VW) * 100 + '%';
        ping.style.top = (ty / VH) * 100 + '%';
        this.anims.push(
          ping.animate(
            [
              { offset: 0, opacity: 0, transform: 'translate(-50%,-50%) scale(0.3)' },
              { offset: 0.6, opacity: 0, transform: 'translate(-50%,-50%) scale(0.3)' },
              { offset: 0.64, opacity: 1, transform: 'translate(-50%,-50%) scale(0.6)' },
              { offset: 1, opacity: 0, transform: 'translate(-50%,-50%) scale(3.2)' },
            ],
            { duration: PERIOD, iterations: Infinity, delay }
          )
        );
      });
      this.running = true;
      this.classList.add('is-animating');
    }
  }

  customElements.define('bteacher-map-hero', BteacherMapHero);
})();
